// var baseUrl = "/api";
var baseUrl = "https://job.gogowork.cn"
// var baseUrl = "https://job.gogowork.cn"
// var baseUrl = "https://job.gogowork.cn"
// var baseUrl = "https://job.gogowork.cn"
// var baseUrl = "http://job-dev.gogowork.cn:4080"

export default {
  indexPages: `${baseUrl}/gogojob-ucenter/common/index`, // 首页
  getUserNameList: `${baseUrl}/gogojob-ucenter/uc/job/recommend/getUserNameList`, // 获取推荐人名字集合
  mainCompanyResource: `${baseUrl}/gogojob-ucenter/vip/resource/mainCompanyResource`, // 获取剩余分配资源
  zhy:`${baseUrl}/gogojob-ucenter/uc/phrases/call`, // 获取招呼语
  workbench:`${baseUrl}/gogojob-ucenter/uc/company/hr/workbench`, // 个人工作台
  businessDetail:`${baseUrl}/gogojob-ucenter/company/getRedis/business`, // 获取营业执照信息
  vipRights:`${baseUrl}/gogojob-ucenter/vip/resource/vipRights`, // 获取会员权益
  messagePages:`${baseUrl}/gogojob-ucenter/back/message/page`, // 待办分页
  downResume:`${baseUrl}/gogojob-ucenter/uc/resume/postResume/downResume`, // 人才管理列表
  updatePayReminder:`${baseUrl}/gogojob-ucenter/uc/companyHrTeam/updatePayReminder`, // 支付优先级设置
  roleHrTeamInfo:`${baseUrl}/gogojob-ucenter/uc/companyHrTeam/roleHrTeamInfo`, // 招聘团队列表
  removeHr:`${baseUrl}/gogojob-ucenter/uc/companyHrTeam/removeHr`, // 取消合作
  messageDetails:`${baseUrl}/gogojob-ucenter/back/message/detail`, // 待办详情
  messageAdds:`${baseUrl}/gogojob-ucenter/back/message/add`, // 添加待办
  phrasesDel:`${baseUrl}/gogojob-ucenter/uc/phrases/delete`, // 删除招呼语
  phrasesEdit: `${baseUrl}/gogojob-ucenter/uc/phrases/edit`, // 修改常用语
  getIsCall: `${baseUrl}/gogojob-ucenter/uc/user/getIsCall`, // 修改招呼语
  jobUrgent: `${baseUrl}/gogojob-ucenter/uc/job/urgent`, // 急招
  downRes: `${baseUrl}/gogojob-ucenter/uc/resume/tasks/downRes`, // b端下载简历
  companyRole: `${baseUrl}/gogojob-ucenter/uc/companyRole/role/page`, // 组织列表
  exportResume: `${baseUrl}/gogojob-ucenter/uc/resume/postResume/exportResume`, // 导出
  pcQrcode: `${baseUrl}/gogojob-ucenter/wechat/qrcode`, // 获取微信二维码
  pcResult: `${baseUrl}/gogojob-ucenter/wechat/qrcode/result`, // 扫码登录
  pushcaptcha: `${baseUrl}/gogojob-ucenter/passport/captcha`, // 获取图片验证码
  sendcode: `${baseUrl}/gogojob-ucenter/passport/sendcode`, // 获取手机验证码
  logout: `${baseUrl}/gogojob-ucenter/passport/logout`, // 退出登录
  login: `${baseUrl}/gogojob-ucenter/passport/login`, // 登录/注册
  dictAll: `${baseUrl}/gogojob-ucenter/dict/all`,  // 下拉字典筛选
  phrasesPage: `${baseUrl}/gogojob-ucenter/uc/phrases/page`,  // 常用语列表
  deleteAddress: `${baseUrl}/gogojob-ucenter/uc/company/address/delete`,  // 删除地址
  industryTree: `${baseUrl}/gogojob-ucenter/common/industry/tree`,  // 期望职位
  industryTreeCertificate: `${baseUrl}/gogojob-ucenter/common/industry/dict`,// 期望职位 带出来的三级 证书要求
  resumeDetail: `${baseUrl}/gogojob-ucenter/uc/user/detail`,  //获取个人信息
  infoDetail: `${baseUrl}/gogojob-ucenter/uc/resume/info`,  //获取简历详情
  updateOne: `${baseUrl}/gogojob-ucenter/uc/resume/update`,  // 首次登录完善信息
  companyAdd: `${baseUrl}/gogojob-ucenter/uc/company/add`,  // 首次登录完善信息(企业)
  uploadLicensePicture: `${baseUrl}/gogojob-ucenter/uc/company/uploadLicensePicture`,  // 上传企业营业执照
  uploadAvatar: `${baseUrl}/gogojob-ucenter/uc/user/uploadAvatar`,  // 上传头像
  uploadHrAvatar: `${baseUrl}/gogojob-ucenter/uc/user/uploadHrAvatar`,  // 上传hr头像
  resumeUpload: `${baseUrl}/gogojob-ucenter/uc/resume/upload`,  // 上传附件简历
  positionSearch: `${baseUrl}/gogojob-ucenter/common/search`,  // 职位、公司搜索
  resumeJobList: `${baseUrl}/gogojob-ucenter/uc/resume-job/list`,  // 获取简历期望职位
  lookJobList: `${baseUrl}/gogojob-ucenter/common/viewJobList`,  // 职位列表->看过的职位列表
  positionDetail: `${baseUrl}/gogojob-ucenter/common/job/info`,  // 职位详情
  companyDetail: `${baseUrl}/gogojob-ucenter/common/company`,  // 企业详情
  erHomeInfo: `${baseUrl}/gogojob-ucenter/uc/user/erHomeInfo`,  // 获取个人信息
  commonUserInfo: `${baseUrl}/gogojob-ucenter/common/userInfo`,  // 邀约信息
  collectJobList: `${baseUrl}/gogojob-ucenter/uc/user/collectJobList`,  // 我收藏的职位
  collectMeList: `${baseUrl}/gogojob-ucenter/uc/company/collectMeList`,  // 收藏了我的职位
  hasChatList: `${baseUrl}/gogojob-ucenter/uc/user/hasChatList`,  // 我沟通过的公司
  hasSendResume: `${baseUrl}/gogojob-ucenter/uc/user/hasSendResume`,  // 我投递过的公司
  collectJob: `${baseUrl}/gogojob-ucenter/uc/user/collect/job`,  // 收藏职位
  collectJobYes: `${baseUrl}/gogojob-ucenter/uc/user/collect/job`,  // 收藏职位
  collectJobNo: `${baseUrl}/gogojob-ucenter/uc/user/uncollect/job`,  // 取消收藏职位
  walletP: `${baseUrl}/gogojob-ucenter/uc/user/wallet/info`,  // 个人钱包
  walletList: `${baseUrl}/gogojob-ucenter/uc/user/wallet/bill`,  // 个人钱包列表
  blacklist: `${baseUrl}/gogojob-ucenter/uc/user/blacklist`,  // 黑名单列表
  unmarkBlack: `${baseUrl}/gogojob-ucenter/uc/user/unmark/black`,  // 取消黑名单
  markkBlack: `${baseUrl}/gogojob-ucenter/uc/user/mark/black`,  // 添加黑名单
  sendSmsToNewMobile: `${baseUrl}/gogojob-ucenter/uc/user/sendSmsToNewMobile`,  // 换绑手机->获取验证码
  changeMobile: `${baseUrl}/gogojob-ucenter/uc/user/changeMobile`,  // 换绑手机->提交
  updateGR: `${baseUrl}/gogojob-ucenter/uc/resume/update/columns`,  // 修改个人介绍
  updateUser: `${baseUrl}/gogojob-ucenter/uc/user/update`,  // 修改个人信息
  jobAdd: `${baseUrl}/gogojob-ucenter/uc/resume-job/add`,  // 新增期望职位
  jobEdit: `${baseUrl}/gogojob-ucenter/uc/resume-job/update`,  // 编辑期望职位
  jobdelete: `${baseUrl}/gogojob-ucenter/uc/resume-job/delete`,  // 删除期望职位
  uploadFile: `${baseUrl}/gogojob-ucenter/common/uploadFile`,  // 简历->上传资格证书
  qualificationAdd: `${baseUrl}/gogojob-ucenter/uc/resume-qualification/add`,  // 添加资格证书
  qualificationdelete: `${baseUrl}/gogojob-ucenter/uc/resume-qualification/delete`,  // 删除资格证书
  qualificationEdit: `${baseUrl}/gogojob-ucenter/uc/resume-qualification/update`,  // 编辑资格证书
  professionalAdd: `${baseUrl}/gogojob-ucenter/uc/resume-professional/add`,  // 添加工作经历
  professionaldelete: `${baseUrl}/gogojob-ucenter/uc/resume-professional/delete`,  // 删除工作经历
  professionalEdit: `${baseUrl}/gogojob-ucenter/uc/resume-professional/update`,  // 添加工作经历
  projectAdd: `${baseUrl}/gogojob-ucenter/uc/resume-project/add`,  // 添加项目经历
  projectdelete: `${baseUrl}/gogojob-ucenter/uc/resume-project/delete`,  // 删除项目经历
  projectEdit: `${baseUrl}/gogojob-ucenter/uc/resume-project/update`,  // 编辑项目经历
  educationAdd: `${baseUrl}/gogojob-ucenter/uc/resume-education/add`,  // 添加教育经历
  educationdelete: `${baseUrl}/gogojob-ucenter/uc/resume-education/delete`,  // 删除教育经历
  educationEdit: `${baseUrl}/gogojob-ucenter/uc/resume-education/update`,  // 编辑教育经历
  destroyUser: `${baseUrl}/gogojob-ucenter/uc/user/destroy`,  // 注销
  markMeet: `${baseUrl}/gogojob-ucenter/uc/chat/markMeet`,  // 标记已约面
  markBlack: `${baseUrl}/gogojob-ucenter/uc/chat/markBlack`,  // 标记黑名单
  markRecomment: `${baseUrl}/gogojob-ucenter/uc/chat/markRecomment`,  // 标记可推荐
  markConsider: `${baseUrl}/gogojob-ucenter/uc/chat/markConsider`,  // 标记待考虑
  markNomatch: `${baseUrl}/gogojob-ucenter/uc/chat/markNomatch`,  // 标记不合适
  getListForUser: `${baseUrl}/gogojob-ucenter/uc/chat/getListForUserIm`,  // 聊天用户列表
  messageList: `${baseUrl}/gogojob-ucenter/uc/chat/messageList`,  // 聊天详情
  sendResume: `${baseUrl}/gogojob-ucenter/uc/chat/sendResume2`,  // 投递简历
  swapMobile: `${baseUrl}/gogojob-ucenter/uc/chat/swapMobile2`,  // 换电话
  swapWechat: `${baseUrl}/gogojob-ucenter/uc/chat/swapWechat2`,  // 换微信
  markHr: `${baseUrl}/gogojob-ucenter/uc/chat/markHr`,  // 求职者编辑hr
  markEr: `${baseUrl}/gogojob-ucenter/uc/chat/markEr`,  // hr编辑求职者
  chatJoin: `${baseUrl}/gogojob-ucenter/uc/chat/join`,  // 加入聊天
  chatSay: `${baseUrl}/gogojob-ucenter/uc/chat/say`,  // 发消息
  readOk: `${baseUrl}/gogojob-ucenter/uc/chat/read`,  // 已读信息
  feedback: `${baseUrl}/gogojob-ucenter/common/feedback`,  // 已读信息
  noLoginInfo: `${baseUrl}/gogojob-ucenter/common/userInfo`,  // 兼容无token获取信息
  phrasesAdd: `${baseUrl}/gogojob-ucenter/uc/phrases/add`,  // 新增常用语
  updateSort: `${baseUrl}/gogojob-ucenter/uc/phrases/updateSort`,  // 排序
  viIndex: `${baseUrl}/gogojob-ucenter/vi/index`,  // 视频面试首页
  viCompany: `${baseUrl}/gogojob-ucenter/vi/company`,  // 视频面试首页->详情
  viIntro: `${baseUrl}/gogojob-ucenter/vi/job/intro`,  // 视频面试首页->详情->职位详情
  newUploadFile:`${baseUrl}/gogojob-admin/uncheck/alOss/upload`, // 上传文件
  videoAdd: `${baseUrl}/gogojob-ucenter/uc/video-resume/add`,  //添加视频
  videoUpdate: `${baseUrl}/gogojob-ucenter/uc/video-resume/upt`,  //添加视频
  getVideos: `${baseUrl}/gogojob-ucenter/uc/video-resume/list`,  //获取视频简历
  inviteCode: `${baseUrl}/gogojob-ucenter/vi/inviteCode`,  // 提评分二维码
  invitationDetails: `${baseUrl}/gogojob-ucenter/uc/vi/invitationDetails`,  // 提评分二维码
  interViewfeedback: `${baseUrl}/gogojob-ucenter/uc/vi/feedback`,  // 提评分二维码

  // 企业端
  getHrHomeInfo: `${baseUrl}/gogojob-ucenter/uc/company/hrHomeInfo`,  //获取企业用户信息 [进入后必须请求一遍 且 更新本地用户数据]
  collectMeListPrise: `${baseUrl}/gogojob-ucenter/uc/company/collectMeList`,  //收藏了我的列表
  notificationSwitch: `${baseUrl}/gogojob-ucenter/uc/company/notificationSwitch`,  //开启急聘
  collectListPrise: `${baseUrl}/gogojob-ucenter/uc/company/collectList`,  //我收藏的列表
  walletPrise: `${baseUrl}/gogojob-ucenter/uc/company/wallet/info`,  //钱包总数
  lsPrise: `${baseUrl}/gogojob-ucenter/uc/company/wallet/bill`,  //交易流水
  czPrise: `${baseUrl}/gogojob-ucenter/uc/company/wallet/recharge/list`,  //充值记录
  service: `${baseUrl}/gogojob-ucenter/uc/job/query/service`,  //查询费用和价格以及是否购买简历
  serviceDownload: `${baseUrl}/gogojob-ucenter/uc/resume/download`,  //购买简历
  companyView: `${baseUrl}/gogojob-ucenter/uc/resume/companyView`,  //查看简历详情
  companyblacklist: `${baseUrl}/gogojob-ucenter/uc/company/blacklist`,  //黑名单列表
  removeBlack: `${baseUrl}/gogojob-ucenter/uc/company/removeBlack`,  //黑名单(解除)
  resumeSrearch: `${baseUrl}/gogojob-ucenter/uc/resume/search`,  //推荐人才搜索
  jobNameList: `${baseUrl}/gogojob-ucenter/uc/job/list`,  //获取职位名称
  companyCollect: `${baseUrl}/gogojob-ucenter/uc/company/collect`,  //收藏用户
  companyuncollect: `${baseUrl}/gogojob-ucenter/uc/company/uncollect`,  //取消收藏用户
  getListForHr: `${baseUrl}/gogojob-ucenter/uc/chat/getListForHrIm`,  //获取联系人列表
  askForResume: `${baseUrl}/gogojob-ucenter/uc/chat/askForResume`,  //求简历
  hrUpdate: `${baseUrl}/gogojob-ucenter/uc/company/hr/update`,  //修改hr
  addressList: `${baseUrl}/gogojob-ucenter/uc/company/address/list`,  //地址管理
  addressAdd: `${baseUrl}/gogojob-ucenter/uc/company/address/add`,  //添加地址
  companyUp: `${baseUrl}/gogojob-ucenter/uc/company/update`,  //编辑公司信息
  roleAdd: `${baseUrl}/gogojob-ucenter/uc/companyRole/role/add`,  //新增组织
  companyHrTeamE: `${baseUrl}/gogojob-ucenter/uc/companyRole/role/edit`,  //编辑组织
  uploadLogo: `${baseUrl}/gogojob-ucenter/uc/company/uploadLogo`,  //上传企业logo
  batchUploadPicture: `${baseUrl}/gogojob-ucenter/uc/company/batchUploadPicture`,  //上传企业图片（相册、荣誉）
  saveAlbum: `${baseUrl}/gogojob-ucenter/uc/company/saveAlbum`,  //保存相册
  saveHonerPic: `${baseUrl}/gogojob-ucenter/uc/company/saveHonerPic`,  //保存证书
  setdefault: `${baseUrl}/gogojob-ucenter/uc/company/address/default`,  //默认地址
  companyJobInfo: `${baseUrl}/gogojob-ucenter/uc/job/info`,  //企业职位
  companyAddJob: `${baseUrl}/gogojob-ucenter/uc/job/add`,  //添加企业职位
  companyEditJob: `${baseUrl}/gogojob-ucenter/uc/job/update`,  //修改企业职位
  companyJobUp: `${baseUrl}/gogojob-ucenter/uc/job/up`,  //企业职位上架
  companyJobDown: `${baseUrl}/gogojob-ucenter/uc/job/down`,  //企业职位下架
  companyJobTop: `${baseUrl}/gogojob-ucenter/uc/job/top`,  //企业职位下架
  companyJobDelete: `${baseUrl}/gogojob-ucenter/uc/job/delete`,  //企业职位删除
  companyQueryService: `${baseUrl}/gogojob-ucenter/uc/job/query/service`,  //服务查询价格
  companyJobRenewal: `${baseUrl}/gogojob-ucenter/uc/job/renewal`,  //续费上架职位
  hotKeywords: `${baseUrl}/gogojob-ucenter/keys/industry/getIndustryByKeysName`,  //热门关键词
  getcalendar: `${baseUrl}/gogojob-ucenter/back/message/calendar`,  //获取日历
  queryHrNameList: `${baseUrl}/gogojob-ucenter/uc/companyHrTeam/queryHrNameList`,  //职位负责人
  postAndDownResume: `${baseUrl}/gogojob-ucenter/uc/resume/postResume/postAndDownResume`,  // 已投递列表
  signUser: `${baseUrl}/gogojob-ucenter/uc/resume/detail/signUser`,  // 修改标记状态
  resumeSign: `${baseUrl}/gogojob-ucenter/uc/resume/update/resumeSign`,  // 修改推荐报告标记状态
  queryHrTeamPayRelated: `${baseUrl}/gogojob-ucenter/uc/companyHrTeam/queryHrTeamPayRelated`,  // 获取支付方式详情
  companyHrTeamexport: `${baseUrl}/gogojob-ucenter/uc/companyHrTeam/export`,  // 招聘团队导出
  companyHrTeamEdit: `${baseUrl}/gogojob-ucenter/uc/companyHrTeam/edit`,  // 变更组织
  hrComeurl: `${baseUrl}/gogojob-ucenter/uc/company/invite/hrComeurl`,  // 邀请成员二维码
  authority: `${baseUrl}/gogojob-ucenter/uc/company/transfer/authority`,  // 移交权限
  resourcelog: `${baseUrl}/gogojob-ucenter/vip/resourcelog/page`,  // 分配记录
  resourcePage: `${baseUrl}/gogojob-ucenter/vip/resource/page`,  // 资源列表
  handleResource: `${baseUrl}/gogojob-ucenter/vip/resource/handleResource`,  // 资源列表
  resourcelogExport: `${baseUrl}/gogojob-ucenter/vip/resourcelog/export`,  // 资源列表
  inVipIdFindRights: `${baseUrl}/gogojob-ucenter/vip/servicerale/inVipIdFindRights`,  // 资源列表
  findVipInfo: `${baseUrl}/gogojob-ucenter/vip/memberset/findVipInfo`,  // 资源列表
  buyVipcompanyId: `${baseUrl}/gogojob-ucenter/vip/resource/buyVip`,  // 购买会员
  companyPay: `${baseUrl}/gogojob-ucenter/uc/company/getPc/companyPay`,  // 购买会员
  queryPayStatus: `${baseUrl}/gogojob-ucenter/uc/company/wx/queryPayStatus`,  // 充值轮询查
  getUserList: `${baseUrl}/gogojob-ucenter/uc/job/recommend/getUserList`,  // pro列表
  isMainCompanUser: `${baseUrl}/gogojob-ucenter/uc/company/isMainCompanUser`,  // 是否为超管
  vipLog: `${baseUrl}/gogojob-ucenter/uc/user/click/log`,  // 记录进入会员页
  modifyMsg:`${baseUrl}/gogojob-ucenter/easemob/modifyTextOrCustomizeMessage`, // 修改消息
  invitation:`${baseUrl}/gogojob-ucenter/uc/vi/invitation`, // 邀请面试
  answerInvitation:`${baseUrl}/gogojob-ucenter/uc/vi/answerInvitation`, // 回应面试邀请
  attendInitial:`${baseUrl}/gogojob-ucenter/uc/vi/attendInitial`, // 参加初试
  invitationAudit:`${baseUrl}/gogojob-ucenter/uc/vi/invitationAudit`, // 面试审核
  invitationStatus:`${baseUrl}/gogojob-ucenter/uc/vi/invitationStatus`, // 面试状态
  inputLog:`${baseUrl}/gogojob-ucenter/common/inputLog`, // 打印日志
  inviteRecord:`${baseUrl}/gogojob-ucenter/uc/vi/inviteRecord/hr`, // 邀约记录
  inviteRecordEr:`${baseUrl}/gogojob-ucenter/uc/vi/inviteRecord`, // 邀约记录
};



// WEBPACK FOOTER //
// ./src/api/config.js